import { render, staticRenderFns } from "./IconScheduleConcluded.vue?vue&type=template&id=4b53f4be"
import script from "./IconScheduleConcluded.vue?vue&type=script&lang=js"
export * from "./IconScheduleConcluded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports